import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgFacebookIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.25 8.9531h-3.6562V6.5156a1.219 1.219 0 0 1 1.2187-1.2187h1.2187V2.25h-2.4374a3.6564 3.6564 0 0 0-3.6563 3.6563V8.953H7.5V12h2.4375v9.75h3.6563V12h2.4374z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgFacebookIcon;
